import angular from 'angular';
import {
  ssDialogService,
  vmSharedModelService,
  loaderService,
  emSharedModelService
} from 'app/services';
import {
  confirmDialog,
  actionIcon,
  alerts
} from 'app/components/global';
import addFunctionVendorDialog from '../dialog.addFunctionVendorDialog';
import addVendorProductDialog from '../products/dialog.addVendorProductDialog';
import controller from './vendor.controller';
import directive from './vendor.directive';
import productDirective from '../products';


export default angular.module('app.components.advisory.enterpriseModeling.vendor', [
  actionIcon,
  confirmDialog,
  ssDialogService,
  loaderService,
  alerts,
  vmSharedModelService,
  addFunctionVendorDialog,
  addVendorProductDialog,
  productDirective,
  emSharedModelService
])
  .directive('emVendor', directive)
  .controller('EMVendorController', controller)
  .name;

console.log('app.components.advisory.enterpriseModeling.vendor created');
